import { render, staticRenderFns } from "./VaChart.vue?vue&type=template&id=d4a0f572"
import script from "./VaChart.vue?vue&type=script&lang=js"
export * from "./VaChart.vue?vue&type=script&lang=js"
import style0 from "./VaChart.vue?vue&type=style&index=0&id=d4a0f572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports